export function getPolygonConDeltail({WIDTH, HEIGHT}) {
  return {
    x: (WIDTH - HEIGHT) / 4 + 15,
    y: HEIGHT * .17,
    width: HEIGHT * .8,
    height: HEIGHT * .8,
    radius: 3
  }

}